import { PredefinedAppointmentItem } from "@/Appointments/Models/Scheduling/PredefinedAppointmentItem";
import { Appointment } from "@/Common/Api/Appointment/Dto/Appointment";

class AppointmentCreateData {
    // base
    public PatientContactId: string;
    public PatientCustomName: string;
    public Start: Date;
    public End: Date;
    public EmployeeIds: string[];
    public SiteId: string;
    public Subject: string;
    public IsPatientNotificationsEnabled: boolean;
    public PatientFirstName: string;
    public PatientPreferredName: string;
    public PatientLastName: string;
    public PatientNAM: string;
    public PatientDOB: Date;

    // Status
    public AppointmentStateLookupId: string;

    public CanadianTriageAndAcuityScore: number;

    // Extras
    public ServiceDefinitionId: string;
    public RoomString: string;
    public IsPaid: boolean;
    public IsTeleconsultation: boolean;
    public Notes: string;
    public ReferralId: string; // Licence of Referral
    public ReferralPhone: string;
    public ReferralOrganizationRuleId: string;
    public CustomReferralDoctorName: string;
    public ContactPointNotificationList: string[];
    public HasNotificationContactPointSpecified: boolean;

    // Underlying Predefined Appointment
    public previousPredefinedAppId: string;
    public PrimaryEmployeeId: string;

    // Questionnaire
    public QuestionnaireId: string;

    public static FromPredefinedAppointmentItem(item: PredefinedAppointmentItem): AppointmentCreateData {
        let tmpComposite = new AppointmentCreateData();
        tmpComposite.Start = IsNullOrWhiteSpace(item.Start) ? null : cacheStore.Helper.CreateDateAsUTC(new Date(item.Start));
        tmpComposite.End = cacheStore.Helper.CreateDateAsUTC(item.GetEnd());
        tmpComposite.EmployeeIds = [item.EmployeeId];
        tmpComposite.SiteId = item.SiteId;
        tmpComposite.Subject = item.Subject;

        if (!item.IsFromRuleSetAvailability) {
            // Underlying Predefined Appointment
            tmpComposite.previousPredefinedAppId = item.PredefinedAppointmentId;
            tmpComposite.PrimaryEmployeeId = item.EmployeeId;
        }

        // Extras
        tmpComposite.ServiceDefinitionId = item.ServiceDefinitionId;

        const serviceDefinition = cacheStore.GetServiceDefinitionById(item.ServiceDefinitionId);
        tmpComposite.QuestionnaireId = serviceDefinition?.GetQuestionnaireId();

        return tmpComposite;
    }

    public static FromAppointment(item: Appointment): AppointmentCreateData {
        let tmpComposite = new AppointmentCreateData();
        tmpComposite.PatientContactId = item.PatientContactId;
        tmpComposite.PatientCustomName = item.PatientNameString;
        tmpComposite.Start = item.StartTime;
        tmpComposite.End = item.EndTime;

        tmpComposite.EmployeeIds = [item.EmployeeId];
        if (item.AppointmentIntervenorIds != null)
            item.AppointmentIntervenorIds.forEach(i => tmpComposite.EmployeeIds.push(i));

        tmpComposite.SiteId = item.SiteId;
        tmpComposite.Subject = item.Subject;
        tmpComposite.IsPatientNotificationsEnabled = item.IsPatientNotificationsEnabled;
        tmpComposite.IsTeleconsultation = item.IsTeleconsultation;
        tmpComposite.ContactPointNotificationList = item.ContactPointNotificationList;
        tmpComposite.HasNotificationContactPointSpecified = item.HasNotificationContactPointSpecified;
        tmpComposite.CanadianTriageAndAcuityScore = item.CanadianTriageAndAcuityScore;

        // Patient
        tmpComposite.PatientFirstName = item.PatientFirstName;
        tmpComposite.PatientPreferredName = item.PatientPreferredName;
        tmpComposite.PatientLastName = item.PatientLastName;
        tmpComposite.PatientNAM = item.PatientNAM;
        tmpComposite.PatientDOB = item.PatientDateOfBirth;

        // Status
        tmpComposite.AppointmentStateLookupId = item.AppointmentStateLookupId;

        // Extras
        tmpComposite.ServiceDefinitionId = item.FilteredResourceDefinitionId;
        tmpComposite.RoomString = item.Location;
        tmpComposite.IsPaid = item.IsPaid;
        tmpComposite.Notes = item.Notes;
        tmpComposite.ReferralId = item.ReferralId;
        tmpComposite.ReferralPhone = item.ReferralPhone;
        tmpComposite.ReferralOrganizationRuleId = item.ReferralOrganizationRuleId;
        tmpComposite.CustomReferralDoctorName = item.CustomReferralDoctorName;

        // Underlying Predefined Appointment
        tmpComposite.previousPredefinedAppId = item.PredefinedAppointmentId;
        tmpComposite.PrimaryEmployeeId = item.EmployeeId;

        // Questionnaire
        tmpComposite.QuestionnaireId = item.QuestionnaireStatusInfo?.QuestionnaireId;

        return tmpComposite;
    }
}

export { AppointmentCreateData };
